import React, {useRef} from "react";
import debounce from "lodash/debounce";

import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchFilledIcon from '../../static/icons/search_filled.svg';

import styles from './SearchFiled.module.scss';
import {COLORS} from "../../config/constants";

type SearchFieldProps = {
  onSearch: (value: string) => void;
  setValue: (value: string) => void;
  value: string;
};

const SearchField = ({onSearch, setValue, value}: SearchFieldProps) => {

  const debouncedRequest = useRef(debounce(onSearch, 1000)).current

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setValue(query);
    debouncedRequest(query);
  };

  const handleClear = () => {
    setValue('');
    onSearch('');
  };

  return <TextField
    fullWidth
    label="Поиск"
    onChange={handleChange}
    value={value}
    sx={{
      '.MuiInputLabel-root': {
        backgroundColor: COLORS.WHITE,
        color: COLORS.GRAY_LIGHT_SECONDARY,
      },
      '.MuiOutlinedInput-input': {
        color: COLORS.GRAY_TEXT,
      },
      '&.Mui-focused': {
        borderWidth: '2px',
      },
    }}
    InputProps={{
      endAdornment: <InputAdornment position='end' onClick={value ? handleClear: undefined}>
        {value ? <span className={styles.searchIcon}>
          <svg width="16" height="16" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="currentColor" />
        </svg>
        </span> : <img src={SearchFilledIcon} alt=""/>}
      </InputAdornment>
    }}
  />
}

export default SearchField
